import { authFetch } from "../../utils/authFetch";

const apiURL = require('./apiURL');
const fetch = authFetch;

const Types = {
    COURSES_DOWNLOADING_CERTIFICATE: "COURSES_DOWNLOADING_CERTIFICATE",
    COURSES_DOWNLOADED_CERTIFICATE: "COURSES_DOWNLOADED_CERTIFICATE"
}


const downloadingCertificates = () => ({
    type: Types.COURSES_DOWNLOADING_CERTIFICATE,
    downloading: true
});

const downloadedCertificates = () => ({
    type: Types.COURSES_DOWNLOADED_CERTIFICATE,
    downloading: false
});

const checkCourseCertificateStepFunction = (arn) => {
    return (dispatch, getState) => {
        fetch(apiURL + `/settings/courses/generateCompletionCertificate/${arn}`, {
            credentials: "include",
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then(response => response.json())
            .then(data => {

                const finished = data.data.status != "RUNNING"

                if (finished) {
                    if (data.data.status == 'SUCCEEDED') {

                        const output = JSON.parse(data.data.output);

                        let popup;
                        output && output.map(item => {
                            popup = window.open(item.url);
                        })
                        if (!popup || popup.closed || typeof popup.closed == 'undefined') {
                            alert('Popup Blocker is enabled! Please add this site to your exception list.');
                        }
                        dispatch(downloadedCertificates())
                    }
                } else {
                    setTimeout(() => dispatch(checkCourseCertificateStepFunction(arn)), 1000)
                }
            });
    }
};

const downloadCertificates = (body) => {
    return (dispatch, getState) => {
        dispatch(downloadingCertificates())
        fetch(apiURL + `/settings/courses/generateCompletionCertificate/`, {
            credentials: 'include',
            method: 'POST',
            body: body,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then(response => response.json())
            .then(data => {

                const arn = data.executionArn;

                setTimeout(() => dispatch(checkCourseCertificateStepFunction(arn)), 1000)
            })
    }
};

const Actions = {
    downloadCertificates
};

export { Types, Actions };